import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { About, Contacts, EventDetails, Events, Home, News, ServiceDetails, Services } from './containers/index';
import { NavigationBar } from './components/index';
import Footer from './components/Footer/Footer';

const navModel = {
  'brand': 'Planet',
  'leftLinks': [
    {
      'label': 'Home',
      'link': '/'
    },
    {
      'label': 'About',
      'link': '/about'
    }
  ],
  'rightLinks': [
    {
      'label': 'News',
      'link': '/news'
    },
    {
      'label': 'Events',
      'link': '/events'
    },
    {
      'label': 'Services',
      'link': '/services'
    },
    {
      'label': 'Contacts',
      'link': '/contacts'
    }
  ]
};

export default (
  <div className="main-app">
    <NavigationBar
      brand={navModel.brand}
      navModel={navModel}
      handleLeftNavItemClick={() => {
      }}
      handleChangeLanguage={() => {
      }}
      handleRightNavItemClick={() => {
      }}/>
    
    <Switch>
      <Route exact path="/" component={Home}/>
      <Route path="/about" component={About}/>
      <Route path="/services/:serviceId" component={ServiceDetails}/>
      <Route path="/services" component={Services}/>
      <Route path="/news" component={News}/>
      <Route path="/events/:eventId" component={EventDetails}/>
      <Route path="/events" component={Events}/>
      <Route path="/contacts" component={Contacts}/>
    </Switch>
    <Footer/>
  </div>
);



// WEBPACK FOOTER //
// ./src/routes.js